import RTECompose from 'contentful/RTE_compose';
import FullScreenVideo from 'contentful/full_screen_video';
import Accordion from 'contentful/accordion';
import CallToActionSection from 'contentful/call_to_action_section';
import CarouselSection from 'contentful/carousel_section';
import ProductSection from 'contentful/product_carousel/product_section';
import HeroBanner from 'contentful/hero_banner';
import MarketoForm from 'contentful/marketo_form';
import GridSection from 'contentful/grid_section';
import ScheduleTable from 'contentful/schedule_table';
import TextSection from 'contentful/text_section';
import MediaSection from 'contentful/media_section';
import QuoteBox from 'contentful/quote_box';
import GreyBox from './grey_box';

const EvergreenContent = ({ content, productReference }) => (
  <div className="evergreen__content">
    {content.map(contentType => {
      let item;
      const contentTypeID = contentType.sys.contentType.sys.id;
      if (contentTypeID === 'videoPlayer') {
        item = {
          link: contentType.fields.url,
          title: contentType.fields.videoTitle,
        };
      }

      switch (contentTypeID) {
        case 'videoPlayer':
          return (
            <FullScreenVideo
              key={contentType.sys.id}
              id={contentType.sys.id}
              item={item}
              containerClass="evergreen__container evergreen__container-large"
            />
          );
        case 'guideSummary':
          return (
            <GreyBox
              key={contentType.sys.id}
              id={contentType.sys.id}
              content={contentType.fields}
            />
          );
        case 'quotationBox':
          return (
            <QuoteBox
              key={contentType.sys.id}
              id={contentType.sys.id}
              content={contentType.fields}
            />
          );
        case 'imageCarousel':
          return (
            <CarouselSection
              key={contentType.sys.id}
              id={`image_carousel_${contentType.sys.id}`}
              content={contentType.fields}
            />
          );
        case 'callToAction':
          return (
            <CallToActionSection
              key={contentType.sys.id}
              id={contentType.sys.id}
              fields={contentType.fields}
            />
          );
        case 'pageImage':
          return (
            <MediaSection
              key={contentType.sys.id}
              id={`media_${contentType.sys.id}`}
              fields={contentType.fields}
            />
          );
        case 'faqGroup':
          return (
            <Accordion
              key={contentType.sys.id}
              id={contentType.sys.id}
              fields={contentType.fields}
            />
          );
        case 'productCarousel':
          return (
            <ProductSection
              fields={contentType.fields}
              productReference={productReference}
              key={contentType.sys.id}
              id={`section_${contentType.sys.id}`}
            />
          );
        case 'heroBanner':
          return (
            <HeroBanner
              fields={contentType.fields}
              pageContent={content}
              key={contentType.sys.id}
            />
          );
        case 'grid':
          return (
            <GridSection
              fields={contentType.fields}
              key={contentType.sys.id}
              id={`section_${contentType.sys.id}`}
            />
          );
        case 'scheduleGroup':
          return (
            <ScheduleTable
              fields={contentType.fields}
              id={`schedule_group_${contentType.sys.id}`}
              key={contentType.sys.id}
            />
          );
        case 'evergreenSection':
          return (
            <TextSection
              fields={contentType.fields}
              id={`section_${contentType.sys.id}`}
              key={contentType.sys.id}
            />
          );
        case 'marketoForm':
          return (
            <MarketoForm
              fields={contentType.fields}
              id={`marketo_form_${contentType.sys.id}`}
              key={contentType.sys.id}
            />
          );
        default:
          return (
            <div
              key={contentType.sys.id}
              id={`section_${contentType.sys.id}`}
              className="evergreen__container evergreen__container-small">
              <div className="evergreen__content__section">
                {contentType.fields.title && (
                  <h2 className="fs-34 m-fs-48 lh-1-2 ff-body mt-0 mb-24">
                    {contentType.fields.title}
                  </h2>
                )}
                {contentType.fields.content && (
                  <RTECompose
                    content={contentType.fields.content}
                    fieldType="content"
                  />
                )}
              </div>
            </div>
          );
      }
    })}
  </div>
);

export default EvergreenContent;
